import { render } from "./dialogSearchBuyProduct.vue?vue&type=template&id=278b47bf&scoped=true"
import script from "./dialogSearchBuyProduct.vue?vue&type=script&lang=js"
export * from "./dialogSearchBuyProduct.vue?vue&type=script&lang=js"

import "./dialogSearchBuyProduct.vue?vue&type=style&index=0&id=278b47bf&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278b47bf"]])

export default __exports__